import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faEye } from '@fortawesome/pro-solid-svg-icons';

export type ProSolidEyeProps = IconComponentProps;

export const ProSolidEye = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProSolidEyeProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faEye}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faEye}
    />
  );
};

ProSolidEye.displayName = 'ProSolidEye';
